import type { EmailFrequency, KeyboardLayout } from '@/graphql/graphql';

export const LOCALES = ['nl'] as ReadonlyArray<Locale>;
export const KEYBOARD_LAYOUTS = [
  'QWERTY',
  'AZERTY',
] as ReadonlyArray<KeyboardLayout>;
export const EMAIL_FREQUENCIES = [
  'DAILY',
  'WEEKLY',
  'NEVER',
] as ReadonlyArray<EmailFrequency>;
export const MAXIMUM_LICENSE_AMOUNT = 250;
export const DEFAULT_LICENSE_AMOUNT = 50;
